import React from 'react'
import Pg4 from '../../../myapp/services/add-money/Pg/Pg4'

function PG4Page() {
  return (
    <Pg4/>
  )
}

export default PG4Page